import { Flex, styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StatusLabel = styled(Flex)`
  z-index: 1;
  display: flex;
  align-items: center;
  border-radius: ${({ theme }) => theme.radii.full};
  background-color: rgba(247, 247, 247, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: ${({ theme }) => theme.colors.mono14};
  font-weight: 500;
  font-family: Inter UI;
  font-size: 14px;
  backdrop-filter: blur(24px);
  letter-spacing: -0.032px;
  align-items: center;
  justify-content: center;
  padding: 0 ${({ theme }) => theme.space[4]};
  height: ${pxToRem(28)};
`;
